import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { HttpService, MessageService } from 'brainloper-ui';
import { QuestionsComponent } from '../generic-question/questions/questions.component';
import { Question } from 'src/app/models/inspections/question';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { DeleteGenericService } from 'src/app/services/delete-generic.service';
import { BaseResponse } from 'src/app/models/commos/base-response';
import { GenericResponse } from 'src/app/models/commos/generic-response';
import { RouterEvent } from '@angular/router';

@Component({
    selector: 'app-questions-bank',
    templateUrl: './questions-bank.component.html',
    styleUrls: ['./questions-bank.component.scss'],
    standalone: false
})
export class QuestionsBankComponent implements OnInit {
  bodyQuestions: Array<Question> = null;
  public questionId: number = 0;

  constructor(
    public dialog: MatDialog,
    private http: HttpService,
    private deleteItem: DeleteGenericService,
    private message: MessageService
  ) {}

  ngOnInit(): void {}

  async init() {
    this.message.openLoading('Cargando', `Cargando Preguntas`);
    let res: Array<Question> = await this.http.getDataBody(
      `${EndpointDictionary.PreopQuestion.ALL_QUESTIONS}`
    );
    this.bodyQuestions = res;
    this.message.closeLoading()
  }

  addNewQuestion() {
    this.handlerQuestions();
  }

  private handlerQuestions(body?: Question) {
    let size: number = screen.width > 500 ? 60 : 50;
    this.dialog
      .open(QuestionsComponent, {
        width: `${size}vh`,
        data: body,
      })
      .afterClosed()
      .subscribe((res) => {
        console.log(res);
        if (res) {
          this.questionId = res;
          this.init();
        }
      });
  }

  async deleteQuestion($event: Question) {
    try {
      const deleteConfirm = await this.message.Warning(`Desea eliminar Pregunta`, ``, true);
      if (!deleteConfirm) {
        this.message.SuccessToast('Operación cancelada');
        return;
      }
  
      this.message.openLoading('Cargando', `Eliminando Pregunta`);
  
      const res: BaseResponse<GenericResponse> = await this.http.deleteDataPromise(
        `${EndpointDictionary.PreopQuestion.CRUD_PREOP_QUESTION_DATA}/${$event.questionId}`
      );
  
      if (res['code'] === 1) {
        const confirm = await this.message.Warning(res.message, '', true);
        if (confirm) {
          const resDelete: BaseResponse<GenericResponse> = await this.http.deleteDataPromise(
            `${EndpointDictionary.PreopQuestion.CRUD_PREOP_QUESTION_DATA}/${$event.questionId}?deleteQuestion=true`
          );
  
          if (resDelete['code'] === 0) {
            this.message.SuccessToast(resDelete.message);
            await this.init();
          } else {
            this.message.Warning('Error!', resDelete.message);
          }
        } else {
          this.message.SuccessToast('Operación cancelada');
        }
      } else if (res['code'] === 0) {
        this.message.SuccessToast(res.message);
        await this.init();
      } else {
        this.message.Warning('Error!', res.message);
      }
    } catch (error) {
      this.message.Warning('Error inesperado', error.message || 'Ocurrió un error al eliminar la pregunta.');
    } finally {
      this.message.closeLoading();
    }
  }

  async editQuestion($event: Question) {
    this.message.openLoading('Cargando', `Editando Pregunta`);
    let res: Array<Question> = await this.http.getDataBody(
      `${EndpointDictionary.PreopQuestion.CRUD_PREOP_QUESTION_DATA}/${$event.questionId}`
    );
    if (res) {
      let body = res[0];
      this.handlerQuestions(body);
    }
    this.message.closeLoading()
  }
}
